import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { applyCachedThemeBeforeMount } from './lib/theme-cache'
import './styles/index.css'

// Paint the cached theme before React mounts (and before this module's own
// CSS import takes effect), so the first paint already matches this
// person's theme instead of flashing Legacy Night — see
// src/lib/theme-cache.ts. Falls through to the CSS's bare `:root` default
// (Legacy Night) when there is nothing cached yet.
applyCachedThemeBeforeMount()

const container = document.getElementById('root')
if (!container) {
  throw new Error('#root element not found — index.html is missing its mount point')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
